export const buildAudioConstraints = (selectedMicrophone: string | null | undefined, autoGainControl: boolean) => ({
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: autoGainControl,
    // Codex audio-quality pass — explicit mono capture. Aligns the
    // capture profile with our `stereo=0` Opus send SDP and stops
    // some Bluetooth/USB headsets from negotiating stereo defaults
    // that the encoder then has to downmix.
    channelCount: 1,
    ...(selectedMicrophone ? { deviceId: { ideal: selectedMicrophone } } : {})
});
